import { render, staticRenderFns } from "./ProjectFilesFooterBar.vue?vue&type=template&id=42803b42&scoped=true&lang=pug&"
import script from "./ProjectFilesFooterBar.vue?vue&type=script&lang=js&"
export * from "./ProjectFilesFooterBar.vue?vue&type=script&lang=js&"
import style0 from "./ProjectFilesFooterBar.vue?vue&type=style&index=0&id=42803b42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42803b42",
  null
  
)

export default component.exports